import { useState } from 'react';
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { Input } from "@/components/ui/input";
import { useAuth } from "@/context/AuthContext";
import { useToast } from "@/components/ui/use-toast";

export function QuickAddTask({ status, scope = 'tracked', releaseId, projectId, organizationSlug, assigneeId, onTaskCreated, alwaysShow = false, buttonText = "Add task", textSize = "text-sm" }) {
  const [isAdding, setIsAdding] = useState(false);
  const [summary, setSummary] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { axiosInstance } = useAuth();
  const { toast } = useToast();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!summary.trim()) return;

    setIsLoading(true);
    try {
      // Use the scope prop passed to the component
      
      const response = await axiosInstance.post(`/tasks/${organizationSlug}`, {
        summary: summary.trim(),
        status,
        scope,
        projectId,
        assigneeId: assigneeId === 'unassigned' ? null : assigneeId,
        releaseId: releaseId || null
      });

      if (response && response.data) {
        onTaskCreated(response.data);
        setSummary('');
        setIsAdding(false);
        toast({
          description: `Task created successfully`,
        });
      }
    } catch (error) {
      console.error('Error creating task:', error);
      toast({
        description: "Failed to create task",
        variant: "destructive",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={`transition-opacity max-md:opacity-100 ${alwaysShow ? 'opacity-100' : isAdding ? 'opacity-100' : 'opacity-0 group-hover:opacity-100'}`}>
      {!isAdding ? (
        <Button
          variant="ghost"
          size="sm"
          className={`w-full justify-start text-muted-foreground hover:text-foreground h-8 ${textSize}`}
          onClick={() => setIsAdding(true)}
        >
          <Plus className="h-4 w-4 mr-2" />
          {buttonText}
        </Button>
      ) : (
        <form onSubmit={handleSubmit} className="space-y-2">
          <div className="relative">
            <Input
              autoFocus
              placeholder="Type and press enter..."
              value={summary}
              onChange={(e) => setSummary(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Escape') {
                  setIsAdding(false);
                  setSummary('');
                }
              }}
              onBlur={() => {
                if (!summary.trim()) {
                  setIsAdding(false);
                }
              }}
              disabled={isLoading}
              className="h-8"
            />
            {isLoading && (
              <div className="absolute right-2 top-1/2 -translate-y-1/2">
                <div className="w-4 h-4 border-2 border-muted border-t-primary rounded-full animate-spin" />
              </div>
            )}
          </div>
        </form>
      )}
    </div>
  );
}